import { Button, Group, Paper, Title } from "@mantine/core";
import * as Sentry from "@sentry/browser";

function DevSettings() {
  function handleSentryTrigger() {
    Sentry.captureMessage(
      "Frontend test message at " + new Date().toLocaleString()
    );
  }

  function triggerError() {
    // @ts-expect-error This is a test error for checking if source maps in Sentry are working
    return {}.map((x) => x);
  }

  return (
    <Paper className="DevSettings" mt="lg">
      <Title variant="paper-header">Entwicklereinstellungen</Title>
      <Group gap="sm">
        <Button color="secondary" onClick={handleSentryTrigger}>
          Testnachricht an Sentry schicken
        </Button>
        <Button color="error" onClick={triggerError}>
          Testfehler triggern
        </Button>
      </Group>
    </Paper>
  );
}

export { DevSettings };
